import { css } from 'linaria';

export const popover = css`
  background-color: var(--background-primary) !important;
  display: flex !important;
  flex-direction: column !important;
  min-width: 280px !important;
  padding: var(--space-100) 0 !important;

  > div:last-of-type {
    display: none !important;
  }
`;

export const shoppingListLink = css`
  /* NOTE: Необходимо для повышения специфичности и перезаписи стилей из LinkButton. */
  &.shoppingListLinkHackSpecific {
    justify-content: flex-start;
    width: 100%;
    padding: var(--space-100) var(--space-150);
    border-radius: 0 !important;
  }
`;

export const shoppingListLinkText = css`
  margin-left: var(--space-100);
  margin-right: auto;
`;

export const shoppingListLinkMobile = css`
  &.shoppingListLinkHackSpecific {
    padding: var(--space-150) var(--space-200);
  }
`;

export const modalStyle = css`
  padding-bottom: var(--space-200);
`;
